import { render, staticRenderFns } from "./VisitConsumablesForms.vue?vue&type=template&id=09025472"
import script from "./VisitConsumablesForms.vue?vue&type=script&lang=ts"
export * from "./VisitConsumablesForms.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports